// STSDT-1093 Pass from back-end
export enum SearchResultSortingRule {
  Relevance = 'relevance',
  DateDescending = 'dateDesc',
  DateAscending = 'dateAsc',
}

export interface SearchResultSortingOption {
  value: SearchResultSortingRule;
  label: string;
}

export type SearchResultMessageType = 'neutral' | 'warning' | 'success' | 'danger';
export interface SearchResultMessageSegment {
  kind: 'text' | 'link';
  text: string;
  href?: string;
}
export interface SearchResultMessage {
  type: SearchResultMessageType;
  segments: SearchResultMessageSegment[];
}

export interface SearchResultSegment {
  kind: 'text' | 'mark';
  text: string;
}

// STSDT-1093 Pass from back-end
export enum SearchResultStatus {
  None = 'none',
  Published = 'published',
  Withdrawn = 'withdrawn',
  Draft = 'draft',
  InDevelopment = 'inDevelopment',
  Replaced = 'replaced',
  Revised = 'revised',
  HistoricalDraft = 'historicalDraft',
}

export interface SearchResultStatusInfo {
  type: SearchResultStatus;
  text: string;
}

// STSDT-1093 Pass from back-end
export enum SearchResultContentType {
  Standard = 'standard',
  Publication = 'publication',
  Eform = 'eform',
  Collection = 'collection',
  Physical = 'physical',
  Other = 'other',
  Training = 'training',
  Service = 'service',
  CommitteePage = 'committeePage',
  ArticlePage = 'articlePage',
  NewsArticlePage = 'newsArticlePage',
  CoursePage = 'coursePage',
  ContentPage = 'contentPage',
  NewsListPage = 'newsListPage',
  CommitteeListPage = 'committeeListPage',
  StartPage = 'startPage',
}

// STSDT-1093 Pass from back-end
export enum SearchResultContentTypeSubType {
  Main = 'Main',
  Amendment = 'AMD',
  Corrigendum = 'COR',
  Consolidated = 'CON',
  Redline = 'REDLINE',
  InterpretationSheet = 'IS',
  Commented = 'COMMENTED',
  Series = 'SERIES',
  NationalAnnex = 'NA',
  NotSet = 'None',
}

export interface SearchResultContentTypeSubTypeInfo {
  value: SearchResultContentTypeSubType;
  text: string;
}

interface SearchResultContentTypeBaseInfo {
  value: SearchResultContentType;
  text: string;
}

export type SearchResultContentTypeInfo =
  | (SearchResultContentTypeBaseInfo & {
      value: SearchResultContentType.Standard;
      subType?: SearchResultContentTypeSubTypeInfo;
    })
  | (SearchResultContentTypeBaseInfo & {
      value: Exclude<SearchResultContentType, SearchResultContentType.Standard>;
      subType?: never;
    });

export interface SearchResultCallToAction {
  href?: string;
  text?: string;
}

export interface SearchResult {
  id: string;
  url: string;
  contentType: SearchResultContentTypeInfo;
  title: string;
  titleSegments?: SearchResultSegment[];
  textLanguage?: string;
  description?: string;
  descriptionSegments?: SearchResultSegment[];
  languages?: string[];
  dateTime?: string[];
  status?: SearchResultStatusInfo;
  message?: SearchResultMessage;
  callToAction?: SearchResultCallToAction;
  openButton?: SearchResultCallToAction;
}

export interface SearchPageInfo {
  page: number;
  perPage: number;
  total: number;
}

export interface SearchFilterItem {
  value: string;
  label: string;
  count: number;
  selected?: boolean;
}

export interface SearchResponseFilters {
  pageType?: SearchFilterItem[];
  productType?: SearchFilterItem[];
  languages?: SearchFilterItem[];
  statuses?: SearchFilterItem[];
  publishers?: SearchFilterItem[];
  sector?: SearchFilterItem[];
}

export interface SearchResponse {
  activeSort: SearchResultSortingRule;
  sortOptions: SearchResultSortingOption[];
  activeLanguage: string;
  results: SearchResult[];
  pageInfo: SearchPageInfo;
  filters?: SearchResponseFilters;
}

export interface SearchRequestFilters {
  pageType?: string[];
  productType?: string[];
  languages?: string[];
  statuses?: string[];
  publishers?: string[];
  sector?: string;
}

export interface SearchBackendFilters {
  collection?: string;
}

export type SearchRequestCombinedFilters = SearchRequestFilters &
  SearchBackendFilters;

export interface SearchRequest {
  query?: string;
  activeSort?: SearchResultSortingRule;
  activeLanguage: string;
  page: number;
  perPage: number;
  filters?: SearchRequestCombinedFilters;
}
